__turbopack_context__.v({
  "description": "GHH0wG_description",
  "iconWrapper": "GHH0wG_iconWrapper",
  "step": "GHH0wG_step",
  "title": "GHH0wG_title",
});
